import { Injectable } from '@angular/core';

export interface CleanupRegistryEntry {
  method: () => void;
  self: any;
}

@Injectable({
  providedIn: 'root'
})
export class CleanupRegistryService {
  protected registry: CleanupRegistryEntry[] = [];

  constructor() {}

  cleanup(): void {
    this.registry.forEach(entry => {
      entry.method.apply(entry.self);
    });
  }

  addHook(entry: CleanupRegistryEntry): void {
    this.registry.push(entry);
  }
}
